import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "css/main.css";
import "css/style.css";
import Topnav from "components/Topnav";
import ExternalNewsCard from "components/team/ExternalNewsCard";
import FAQCard from "components/team/FAQCard";
import entranceImg from "img/entradaequipas.png";

import { getNews } from "services/external_link_service";
import { getFaqArticles } from "services/article_service";

function App() {
  const [newsList, setNewsList] = useState([]);
  const [faqList, setFaqList] = useState([]);

  useEffect(() => {
    async function initComponent() {
      let newsList = await getNews();
      let faqlst = await getFaqArticles();

      setNewsList(newsList);
      setFaqList(faqlst);
    }
    initComponent();
  }, []);

  return (
    <div className="geral">
      <Topnav></Topnav>
      <div className="conteudo">
        <div className="geral">
          <div className="hero is-footsolution">
            <div className="columns">
              <div className="column">
                <img
                  src={entranceImg}
                  style={{ minHeight: "150px", width: "100%" }}
                  className="title is-3"
                />
              </div>
            </div>
            <section className="section dashboard">
              <h2 className="bold">Notícias</h2>
              <div
                style={{
                  overflowX: "scroll",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {newsList.map((el) => (
                  <>
                    <ExternalNewsCard
                      filters={el.attributes.filtros}
                      title={el.attributes.title}
                      url={el.attributes.url}
                      publicationDate={el.attributes.publication_date}
                    ></ExternalNewsCard>
                  </>
                ))}
              </div>
              <br></br>
              <br></br>
              <h2 style={{"textAlign": "center", "fontSize": "25px"}} className="bold">Questões Frequentes</h2>

              <div className="columns is-multiline">
                  <div className="column is-12">
                    <a className="flex faqbox" href={"https://www.footsolution.pt"} >
                      <span>Consulta as questões mais frequentes <span style={{"fontWeight" : "600"}}>aqui</span></span>
                    </a>
                  </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
